import { render, staticRenderFns } from "./AddPickupPoint.vue?vue&type=template&id=0683fcda"
import script from "./AddPickupPoint.vue?vue&type=script&lang=js"
export * from "./AddPickupPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports